import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { Counter } from '@vk-hr-tek/ui/Counter';
import { Link } from '@vk-hr-tek/ui/Link';

import { modules } from '@app/modules';

import { useSearchQueryParams, useUrlWithPrefix } from '../../../../hooks';
import { SearchLabelOption, LoadItemsFilter } from '../SearchInput.types';

interface SearchOptionLabelProps {
  option: SearchLabelOption;
  filter: LoadItemsFilter;
  onClose: () => void;
}

const LIMIT_TO_SHOW = 999;

export const SearchOptionLabel = ({
  option,
  filter,
  onClose,
}: SearchOptionLabelProps) => {
  const urlWithPrefix = useUrlWithPrefix();
  const queryParams = useSearchQueryParams({
    ...filter,
    group: option.id,
  });

  const hrefGlobalSearch = `/${modules.search.basename}${queryParams}`;

  const preventCloseDropdown = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Box
      height={26}
      width="100%"
      pt="2"
      px="8"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      onMouseDown={preventCloseDropdown}
    >
      <Typography
        variant="subtitle2"
        color="text.light.tertirary"
        maxLinesCount={1}
        wordBreak="break-all"
      >
        {option.label}
      </Typography>
      <Tooltip
        placement="left"
        title="Количество найденных результатов похожих на ваш запрос. Уточните поиск, чтобы увидеть наиболее подходящие варианты"
      >
        <Box display="flex" alignItems="center" flexDirection="row" gap="4">
          {filter.group !== option.id && (
            <Box onClick={onClose}>
              <Link {...urlWithPrefix(hrefGlobalSearch)} variant="simple">
                <Typography variant="body3" color="original.brand.primary">
                  Перейти ко всем
                </Typography>
              </Link>
            </Box>
          )}
          <Counter
            counter={
              option.total > LIMIT_TO_SHOW ? `${LIMIT_TO_SHOW}+` : option.total
            }
            color="blue"
            backgroundColor="lightBlue"
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
